'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CmsText = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _markdown = require('helpers/markdown');

var _verify = require('helpers/verify');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ALIGNMENTS = ['left', 'center', 'right'];
var CONTENT_SIZES = ['tiny', 'small', 'regular', 'medium', 'large', 'huge'];

var CmsText = exports.CmsText = function CmsText(_ref) {
  var _classNames;

  var alignment = _ref.alignment,
      cmsModuleId = _ref.cmsModuleId,
      content = _ref.content,
      size = _ref.size;

  if ((0, _verify.isBlank)(content)) {
    return null;
  }

  var textClasses = (0, _classnames2.default)((_classNames = {
    CmsText: true
  }, (0, _defineProperty3.default)(_classNames, 'CmsText--align-' + alignment, ALIGNMENTS.includes(alignment)), (0, _defineProperty3.default)(_classNames, 'CmsText--size-' + size, CONTENT_SIZES.includes(size)), _classNames));

  return _react2.default.createElement(
    'div',
    { className: textClasses },
    (0, _markdown.renderMarkdown)(content, 'Text:' + cmsModuleId)
  );
};

CmsText.propTypes = {
  alignment: _propTypes2.default.oneOf(ALIGNMENTS),
  cmsModuleId: _propTypes2.default.string.isRequired,
  content: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(CONTENT_SIZES)
};